export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20lifestyle%20flatlay%20overhead%20view%20of%20curated%20clothing%20and%20accessories%20arranged%20artfully%20on%20light%20marble%20surface%20with%20sneakers%20hoodie%20watch%20sunglasses%20bag%20and%20perfume%20bottle%20soft%20natural%20window%20light%20warm%20cream%20beige%20neutral%20tones%20editorial%20product%20photography%20with%20organic%20composition%20elegant%20modern%20aesthetic&width=1600&height=900&seq=hero-bg-vigorbuy-02&orientation=landscape"
          alt="Vigorbuy Spreadsheet product discovery"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 text-xs font-medium mb-6 whitespace-nowrap">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-sparkling-line text-xs"></i>
            </span>
            Premium Product Discovery Platform
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5 md:mb-6">
            Vigorbuy Spreadsheet &mdash; Smart Solutions for{' '}
            <span className="text-primary-300">Better Discovery</span>
          </h1>

          <p className="text-background-50/80 text-base md:text-lg leading-relaxed max-w-2xl mb-8 md:mb-10">
            Discover powerful product collections organized across 14 premium categories. From Shoes and Hoodies to Accessories and Perfumes, Vigorbuy Spreadsheet is your gateway to smarter, more organized shopping.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/20 whitespace-nowrap cursor-pointer"
            >
              <span>Vigorbuy Spreadsheet</span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-base"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>Buy It Now</span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-base"></i>
              </span>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            {['14+ Categories', 'Curated Products', 'Free Access', 'Always Updated'].map((badge) => (
              <div key={badge} className="flex items-center gap-2 text-background-50/70 text-xs">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400 text-sm"></i>
                </span>
                {badge}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}